var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.6842 8.09572C16.076 7.8254 16.4913 8.16632 16.4324 8.63553L16.2678 9.94441C17.9732 10.149 19.1859 11.6652 18.9765 13.3311C18.7671 14.9969 17.2149 16.1816 15.5096 15.977C13.8042 15.7725 12.5915 14.2562 12.8009 12.5904C13.0258 10.8017 14.4867 8.92201 15.6842 8.09572ZM7.90681 8.09572C8.29859 7.8254 8.71391 8.16632 8.65494 8.63553L8.49042 9.94441C10.1958 10.149 11.4085 11.6652 11.1991 13.3311C10.9897 14.9969 9.43749 16.1816 7.73216 15.977C6.02682 15.7725 4.81412 14.2562 5.02351 12.5904C5.24833 10.8017 6.70925 8.92201 7.90681 8.09572Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt2);
export default __webpack_public_path__ + "static/media/quote-alt-2.6a4cc9fa37c0a288ce505143714fd99f.svg";
export { ForwardRef as ReactComponent };